import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';

import AddToCartButton from '../containers/AddToCartButton';
import GalleryCartSummary from '../containers/GalleryCartSummary';
import store from '../store';

export default class GalleryActionBox extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <IntlProvider locale="en">
          <div className="GalleryActionBox">
            <div className="GalleryActionBox__summary">
              <GalleryCartSummary />
            </div>
            <AddToCartButton className={`GalleryActionBox__button`} />
          </div>
        </IntlProvider>
      </Provider>
    );
  }
}
